import { render } from "./FeedbackCarousel.vue?vue&type=template&id=1d17ed55&scoped=true"
import script from "./FeedbackCarousel.vue?vue&type=script&lang=js"
export * from "./FeedbackCarousel.vue?vue&type=script&lang=js"

import "./FeedbackCarousel.vue?vue&type=style&index=0&id=1d17ed55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d17ed55"]])

export default __exports__